// extracted by mini-css-extract-plugin
export var menuItem = "w_tt d_fY d_by d_bC d_bN d_bd";
export var menuItemSub = "w_tv d_Y d_by d_bN";
export var menuMainLink = "w_tw d_fZ d_dz";
export var menuLink = "w_tx d_fZ d_dz";
export var icon = "w_pC d_bB d_bN";
export var divider = "w_ty d_bB d_bN";
export var sublinks = "w_tz";
export var link = "w_mB";
export var Link = "w_rs q_rs q_qN q_q6";